<template>
  <div class="body">
      <Headtow></Headtow>
      <div class="banner">
          <img src="/static/img/bannerss.jpg" alt="" class="banner_dimg">
          <div class="bnnaer_seach">

            <el-select v-model="value" placeholder="全部" class="my-el-select">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>

            <el-input v-model="input" class="borderNone" placeholder="请输入书号、书名、出版社、作者模糊搜索"></el-input>

            <i class="el-icon-search sousou" @click="sousuo" ></i>

          </div>
      </div>

      <div id="w-center">
        <div class="h-30"></div>
        <div class="index_left">
          <div class="xian"></div>
           <p class="china_type">中图法分类</p>
           <ul class="index_ul">
             <li class="index_ul_li">全部分类</li>
             <li class="index_ul_li" v-for="(item, index) in type" :key="item.id" @click="typetow(item.id)">{{item.title}} <span>{{item.cont}}</span></li>
           </ul>
           <div v-for="(item, index) in about_list" :key="item.id" style="width: 90%;margin-top: 10px;">
             <router-link :to="`/AboutCont?id=`+item.id" class="pub_duo">
               <img :src="item.picurl" alt="" style="width: 100%;" />
             </router-link>
           </div>

        </div>
        <div class="inde_right">
          <img src="/static/img/sjdsr.jpg" alt="">
          <div class="index_pub_title">
              <p class="pub_d_title">同类图书馆</p>
              <router-link :to="`/Tlpro`" class="pub_duo">
                更多+
              </router-link>
              <div class="pub_xian"></div>
          </div>

          <ul class="tsg_ul">
            <li class="tsg_li"  v-for="(item, index) in product_list">
             <router-link :to="`/TlproCont?id=`+item.id" class="pub_duo">
                <img :src="item.picurl" alt="" class="tsg_li_img">
                <p class="tsg_li_title">{{item.title}}</p>
              </router-link>
            </li>
          </ul>


          <div class="index_pub_title">
              <p class="pub_d_title">畅销排行榜</p>
              <router-link :to="`/Book?bq=29`" class="pub_duo">更多+  </router-link>
              <div class="pub_xian"></div>
          </div>

          <ul class="tsg_ul">
            <li class="tsg_li_dz"  v-for="(item, index) in phb">
              <div class="img_div">
                <router-link :to="`/Bookcont?id=`+item.id" class="pub_duo" >
                   <img src="/static/img/gbj.png" alt="" class="dz_li_img" v-if="item.picurl ==''" :title="item.title">
                   <img :src="item.picurl" alt="" class="dz_li_img" v-else :title="item.title">
                   <p class="img_div_title" :title="item.title">{{item.title}}</p>
                 </router-link>

              </div>

              <div class="tj_jg">
                <p class="tj_money">￥{{item.old_price}}</p>
                <p @click="handleClick(item.id,1)">  <i class="el-icon-shopping-cart-full gwc" ></i></p>
              </div>
            </li>
          </ul>


          <div class="index_pub_title">
              <p class="pub_d_title">精品推荐</p>
              <router-link :to="`/Book?bq=26`" class="pub_duo">更多+  </router-link>
              <div class="pub_xian"></div>
          </div>

          <ul class="tsg_ul">
            <li class="tsg_li_dz"  v-for="(item, index) in jptj">
              <div class="img_div">
                <router-link :to="`/Bookcont?id=`+item.id" class="pub_duo">
                   <img src="/static/img/gbj.png" alt="" class="dz_li_img" v-if="item.picurl ==''" :title="item.title">
                   <img :src="item.picurl" alt="" class="dz_li_img" v-else :title="item.title">
                   <p class="img_div_title" :title="item.title">{{item.title}}</p>
                 </router-link>
              </div>
              <div class="tj_jg">
                <p class="tj_money">￥{{item.old_price}}</p>
                <p @click="handleClick(item.id,1)">  <i class="el-icon-shopping-cart-full gwc" ></i></p>
              </div>
            </li>
          </ul>



          <div class="index_pub_title">
              <p class="pub_d_title">读者荐购</p>
              <router-link :to="`/Book?bq=25`" class="pub_duo">
                更多+
              </router-link>
              <div class="pub_xian"></div>
          </div>

          <ul class="tsg_ul">
            <li class="tsg_li_dz"  v-for="(item, index) in dltj">
              <div class="img_div">
                  <router-link :to="`/Bookcont?id=`+item.id" class="pub_duo">
                    <img src="/static/img/gbj.png" alt="" class="dz_li_img" v-if="item.picurl ==''" :title="item.title">
                    <img :src="item.picurl" alt="" class="dz_li_img" v-else :title="item.title">
                    <p class="img_div_title" :title="item.title">{{item.title}}</p>
                 </router-link>
              </div>
              <div class="tj_jg">
                <p class="tj_money">￥{{item.old_price}}</p>
                <p @click="handleClick(item.id,1)"><i class="el-icon-shopping-cart-full gwc" ></i></p>
              </div>
            </li>
          </ul>





          <div class="index_pub_title">
              <p class="pub_d_title">书目下载区</p>
              <router-link :to="`/Booklist`" class="pub_duo">
                更多+
              </router-link>
              <div class="pub_xian"></div>
          </div>

          <ul class="yd_ul">
            <li class="tsg_li_ml"  v-for="(item, index) in ydml_list" @click="downloadFile(item.file)">
                 <img src="/static/img/ydml.png" alt="" >
                 <p class="ydml_title">{{item.title}}</p>
            </li>
          </ul>



        </div>
      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,
      info:[],
      left:[],
      input: '',
      options: [{
        value: 'tm',
        label: '书号'
      }, {
        value: 'title',
        label: '书名'
      }, {
        value: 'cbs',
        label: '出版社'
      }, {
        value: 'zz',
        label: '作者'
      }, {
        value: 'cbrq',
        label: '出版日期'
      }, {
        value: 'ztfl',
        label: '中图分类'
      }],
      value: '',
      product_list:[],
      dltj:[],
      ydml_list:[],
      jptj:[],
      type:[],
      about_list:[],
      phb:[],
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Foot': foot,
  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    typetow(e){
        this.$router.push({path:'/Book',query:{typeid:e}});
    },
    sousuo(){
      this.$router.push({path:'/Book',query:{type:this.value,keywore:this.input}});
    },
    recordapi(){
        var that = this;

        that.$api.post("/index/index",{'id':that.id}).then(res => {
          console.log(res);
          that.info= res.info;
          that.left= res.left;
          that.product_list = res.product_list
          that.dltj = res.dltj
          that.ydml_list = res.ydml_list
          that.jptj = res.jptj
          that.loading = false
          that.type =res.type
          that.about_list = res.about_list
          that.phb = res.phb
        });
    },
    getCont(id){
      this.loading = true
      this.id=id;
      this.recordapi();
    },

    downloadFile(fileName) {
      const fileUrl = fileName; // 文件的URL地址
      window.open("http://wfback.test1.dongbo.ren/"+fileUrl);
    },
    handleClick(index,e) {
      if(e == 2){
        if(this.radio=='0'){
          this.$message.error('请选择订单');
          return;
        }
      }
      var that = this;
      var row = index;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Goods/buy",{'gid':index,'userid':userid,'status':'cart','gordernumber':0}).then(res => {
        console.log(res);

        if(res.code==1){
          this.$message({
            message: res.msg,
            type: 'success'
          });
        }
      });
    },


  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Index.vue